/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The scope being requested.
 */
export const RequestAccessFormScope = {
  OrgRead: "org:read",
  OrgAdmin: "org:admin",
  ProjectRead: "project:read",
  ProjectWrite: "project:write",
  McpRead: "mcp:read",
  McpWrite: "mcp:write",
  McpConnect: "mcp:connect",
  EnvironmentRead: "environment:read",
  EnvironmentWrite: "environment:write",
  SkillRead: "skill:read",
  SkillWrite: "skill:write",
  PluginWrite: "plugin:write",
  RiskPolicyEvaluate: "risk_policy:evaluate",
  RiskPolicyBypass: "risk_policy:bypass",
  ChatRead: "chat:read",
  ChatWrite: "chat:write",
  InferenceExecute: "inference:execute",
  LogRead: "log:read",
  AgentRead: "agent:read",
  AgentWrite: "agent:write",
  AgentAuthorize: "agent:authorize",
  AgentTransfer: "agent:transfer",
  WorkloadRead: "workload:read",
  WorkloadWrite: "workload:write",
  OrgDeviceAgentSync: "org:device_agent_sync",
  OrgHooksIngest: "org:hooks_ingest",
} as const;
/**
 * The scope being requested.
 */
export type RequestAccessFormScope = ClosedEnum<typeof RequestAccessFormScope>;

/**
 * Form for requesting access to a scope.
 */
export type RequestAccessForm = {
  /**
   * Optional message from the requester explaining why they need access.
   */
  message?: string | undefined;
  /**
   * Optional resource ID the scope applies to.
   */
  resourceId?: string | undefined;
  /**
   * Optional human-readable name for the resource (e.g. project name, MCP server name).
   */
  resourceName?: string | undefined;
  /**
   * The scope being requested.
   */
  scope: RequestAccessFormScope;
};

/** @internal */
export const RequestAccessFormScope$outboundSchema: z.ZodMiniEnum<
  typeof RequestAccessFormScope
> = z.enum(RequestAccessFormScope);

/** @internal */
export type RequestAccessForm$Outbound = {
  message?: string | undefined;
  resource_id?: string | undefined;
  resource_name?: string | undefined;
  scope: string;
};

/** @internal */
export const RequestAccessForm$outboundSchema: z.ZodMiniType<
  RequestAccessForm$Outbound,
  RequestAccessForm
> = z.pipe(
  z.object({
    message: z.optional(z.string()),
    resourceId: z.optional(z.string()),
    resourceName: z.optional(z.string()),
    scope: RequestAccessFormScope$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      resourceId: "resource_id",
      resourceName: "resource_name",
    });
  }),
);

export function requestAccessFormToJSON(
  requestAccessForm: RequestAccessForm,
): string {
  return JSON.stringify(
    RequestAccessForm$outboundSchema.parse(requestAccessForm),
  );
}
